import React from 'react'
import { showKiloOrMillion } from 'Utils/number'
import { BundlesStepUpToBold } from 'Features/pricing/tabs/Bundles/Bundle.styled'
import { Trans } from 'react-i18next'

type UpToVisitsProps = {
  numOfVisits: number
  maxVisits: number
}

export const UpToVisits = ({ numOfVisits, maxVisits }: UpToVisitsProps) => {
  return maxVisits >= numOfVisits ? (
    <Trans
      ns="pricing"
      i18nKey="bundles.up_to_visits"
      values={{ visits: showKiloOrMillion(numOfVisits * 1000) }}
    >
      Up to <BundlesStepUpToBold /> yearly visits coming from paid marketing
    </Trans>
  ) : (
    <Trans
      ns="pricing"
      i18nKey="bundles.more_than_visits"
      values={{ visits: showKiloOrMillion(maxVisits * 1000) }}
    >
      More than <BundlesStepUpToBold /> yearly visits coming from paid marketing
    </Trans>
  )
}
